import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

class CompanyInfo extends Component {
  capitaliseFirst = (string) => {
    const clearString = string.replace('_', ' ').toLowerCase();
    return clearString[0].toUpperCase() + clearString.slice(1);
  };

  render() {
    const { company, account } = this.props;
    if (!company || !account) {
      return null;
    }

    const { details, source } = account;
    const { sort_code: sortCode } = details;
    const { company_type: companyType, title: companyTitle, address } = company;

    const showSortCode = source !== 'openbanking';

    return (
      <div className={styles.CompanyInfo}>
        <div>
          <div className={styles.CompanyInfoCustomer}>{companyTitle}</div>
          <div className={styles.CompanyInfoValue}>{this.capitaliseFirst(companyType)}</div>
        </div>
        <div>
          <div style={{ visibility: showSortCode ? 'visible' : 'hidden' }}>
            Sort code:&nbsp;
            <span className={styles.CompanyInfoValue}>{sortCode}</span>
          </div>
          <div>
            Address:&nbsp;
            <span className={styles.CompanyInfoValue}>{address}</span>
          </div>
        </div>
      </div>
    );
  }
}

CompanyInfo.propTypes = {
  company: PropTypes.shape({
    sort_code: PropTypes.string,
    account_number: PropTypes.string,
    title: PropTypes.string,
    company_type: PropTypes.string,
    address: PropTypes.string,
  }),
  account: PropTypes.shape({
    company_type: PropTypes.string,
    title: PropTypes.string,
    source: PropTypes.string,
    details: PropTypes.shape({
      sort_code: PropTypes.string,
    }),
  }),
};

const mapStateToProps = ({ appService, accountService }) => ({
  company: accountService.company,
  account: accountService.account,
  alias: appService.alias,
});

CompanyInfo.defaultProps = {
  company: null,
  account: null,
};

export default connect(mapStateToProps)(CompanyInfo);
